var AdobeAn;
import 'latest-createjs';

(function (cjs, an) {

    var p; // shortcut to reference prototypes
    var lib={};var ss={};var img={};
    lib.ssMetadata = [];


// symbols:



    (lib._04 = function() {
        this.initialize(img._04);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,3000,2000);


    (lib.apple = function() {
        this.initialize(img.apple);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,99,88);


    (lib.Bitmap1 = function() {
        this.initialize(img.Bitmap1);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,560,575);


    (lib.box = function() {
        this.initialize(img.box);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,149,126);


    (lib.vs_center = function() {
        this.initialize(img.vs_center);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,168,516);


    (lib.vs_hor = function() {
        this.initialize(img.vs_hor);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,387,73);


    (lib.vs_left = function() {
        this.initialize(img.vs_left);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,252,361);


    (lib.vs_rght = function() {
        this.initialize(img.vs_rght);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0,0,252,359);// helper functions:

    function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }


    (lib.shapes7 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill("#242424").beginStroke().moveTo(-67.6,61.9).curveTo(-75.1,39.1,-86.6,28.3).curveTo(-98.1,17.5,-90.8,-2.2).curveTo(-83.6,-21.9,-71.2,-28.6).curveTo(-58.9,-35.4,-52.6,-44.4).curveTo(-46.4,-53.4,-40.5,-59.3).curveTo(-34.7,-65.1,-27.6,-65.3).curveTo(-20.5,-65.5,-6.9,-58.7).curveTo(6.7,-52,25.1,-63.6).curveTo(43.5,-75.2,60.5,-73.9).curveTo(77.5,-72.5,85.5,-62.6).curveTo(93.5,-52.6,93.7,-34).curveTo(93.8,-15.3,65.6,-3.1).curveTo(37.3,9.1,38.8,35.4).lineTo(39,37.6).lineTo(39,38.6).curveTo(39,48,32.4,54.6).curveTo(25.7,61.3,16.3,61.3).curveTo(10.4,61.3,4.7,58.6).curveTo(-18.1,47.7,-32.9,44.4).curveTo(-42.4,44,-51.3,64.4).curveTo(-55.5,74,-59.4,74).curveTo(-63.7,74,-67.6,61.9).closePath();
        this.shape.setTransform(-14.632,-12.9437);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.shapes7, new cjs.Rectangle(-108.3,-86.9,187.39999999999998,148), null);


    (lib.shadov = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill("#000000").beginStroke().moveTo(-61.9,7.4).curveTo(-87.5,4.3,-87.5,0).curveTo(-87.5,-4.3,-61.9,-7.5).curveTo(-36.3,-10.5,0,-10.5).curveTo(36.2,-10.5,61.8,-7.5).curveTo(87.5,-4.3,87.5,0).curveTo(87.5,4.3,61.8,7.4).curveTo(36.2,10.5,0,10.5).curveTo(-36.3,10.5,-61.9,7.4).closePath();
        this.shape.setTransform(0,0,0.8689,1.36);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.shadov, new cjs.Rectangle(-76,-14.3,152.1,28.6), null);


    (lib.ptrn4_mow = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.Bitmap1();
        this.instance.parent = this;
        this.instance.setTransform(-280,-288);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn4_mow, new cjs.Rectangle(-280,-288,560,575), null);


    (lib.pt44 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib._04();
        this.instance.parent = this;
        this.instance.setTransform(-1500,-1000);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pt44, new cjs.Rectangle(-1500,-1000,3000,2000), null);


    (lib.vs_hor_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.vs_hor();
        this.instance.parent = this;
        this.instance.setTransform(-194,-30);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.vs_hor_1, new cjs.Rectangle(-194,-30,387,73), null);


    (lib.box_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.box();
        this.instance.parent = this;
        this.instance.setTransform(-74.5,-63);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.box_1, new cjs.Rectangle(-74.5,-63,149,126), null);


    (lib.apl = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.instance = new lib.apple();
        this.instance.parent = this;
        this.instance.setTransform(-49.5,-44);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.apl, new cjs.Rectangle(-49.5,-44,99,88), null);


    (lib.letter_02_L = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.beginFill("#1E64F2").beginStroke().moveTo(35.4,142.9).lineTo(35.4,103.3).lineTo(61.6,103.3).lineTo(49,63.9).lineTo(-52.7,63.9).lineTo(-59,82.8).lineTo(-65.3,103.3).lineTo(-38.3,103.3).lineTo(-38.3,142.9).lineTo(-144.7,142.9).lineTo(-144.7,103.3).lineTo(-121.8,103.3).lineTo(-35.3,-142.9).lineTo(38.3,-142.9).lineTo(122,103.3).lineTo(144.7,103.3).lineTo(144.7,142.9).closePath().moveTo(37.5,25.5).lineTo(6.2,-73.9).lineTo(3.3,-84.4).lineTo(0.1,-95.6).lineTo(-1.1,-95.6).lineTo(-7.8,-73.4).lineTo(-15.4,-50).lineTo(-23.9,-23.8).lineTo(-32.4,2.4).lineTo(-39.9,25.5).lineTo(37.5,25.5).closePath();
        this.shape.setTransform(-0.025,-38.9);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter_02_L, new cjs.Rectangle(-155.1,-210,310.29999999999995,420), null);


    (lib.ptrn4 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.pt = new lib.ptrn4_mow();
        this.pt.name = "pt";
        this.pt.parent = this;
        this.pt.setTransform(37.65,45);
        this.pt.cache(-282,-290,564,579);

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.ptrn4, new cjs.Rectangle(-242.3,-243,560,575), null);


    (lib.pattern_img_4 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.pt = new lib.pt44();
        this.pt.name = "pt";
        this.pt.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.pt).wait(1));

    }).prototype = getMCSymbolPrototype(lib.pattern_img_4, new cjs.Rectangle(-1500,-1000,3000,2000), null);


    (lib.vs_rgth = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // apple.png
        this.apl = new lib.apl();
        this.apl.name = "apl";
        this.apl.parent = this;
        this.apl.setTransform(5.5,249);

        this.timeline.addTween(cjs.Tween.get(this.apl).wait(1));

        // vs_rght.png
        this.instance = new lib.vs_rght();
        this.instance.parent = this;
        this.instance.setTransform(-124,-4);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    }).prototype = getMCSymbolPrototype(lib.vs_rgth, new cjs.Rectangle(-124,-4,252,359), null);


    (lib.vs_left_1 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_1
        this.box = new lib.box_1();
        this.box.name = "box";
        this.box.parent = this;
        this.box.setTransform(-2.5,271);

        this.instance = new lib.vs_left();
        this.instance.parent = this;
        this.instance.setTransform(-130,-5);

        this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.box}]}).wait(1));

    }).prototype = getMCSymbolPrototype(lib.vs_left_1, new cjs.Rectangle(-130,-5,252,361), null);


    (lib.vs = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // vs_center.png
        this.instance = new lib.vs_center();
        this.instance.parent = this;
        this.instance.setTransform(-84,-247);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

        // box.png
        this.left = new lib.vs_left_1();
        this.left.name = "left";
        this.left.parent = this;
        this.left.setTransform(-162.2,-194.4);

        this.timeline.addTween(cjs.Tween.get(this.left).wait(1));

        // apple.png
        this.rgh = new lib.vs_rgth();
        this.rgh.name = "rgh";
        this.rgh.parent = this;
        this.rgh.setTransform(162.8,-124.15);

        this.timeline.addTween(cjs.Tween.get(this.rgh).wait(1));

        // vs_hor.png
        this.hor = new lib.vs_hor_1();
        this.hor.name = "hor";
        this.hor.parent = this;
        this.hor.setTransform(-0.5,-160.5,1,1,12.9995,0,0,0,-0.1);

        this.timeline.addTween(cjs.Tween.get(this.hor).wait(1));

    }).prototype = getMCSymbolPrototype(lib.vs, new cjs.Rectangle(-292.2,-247,583,516), null);


    (lib.letter = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // letter1
        this.letter1 = new lib.letter_02_L();
        this.letter1.name = "letter1";
        this.letter1.parent = this;

        this.timeline.addTween(cjs.Tween.get(this.letter1).wait(1));

        // letter2
        this.letter2 = new lib.letter_02_L();
        this.letter2.name = "letter2";
        this.letter2.parent = this;
        this.letter2.setTransform(0,0,0.9,0.9);
        this.letter2.filters = [new cjs.ColorFilter(0.7, 0.7, 0.7, 1, 0, 0, 0, 0)];
        this.letter2.cache(-157,-212,314,424);

        this.timeline.addTween(cjs.Tween.get(this.letter2).wait(1));

        // letter3
        this.letter3 = new lib.letter_02_L();
        this.letter3.name = "letter3";
        this.letter3.parent = this;
        this.letter3.setTransform(0,0,0.8,0.8);
        this.letter3.filters = [new cjs.ColorFilter(0.51, 0.51, 0.51, 1, 0, 0, 0, 0)];
        this.letter3.cache(-157,-212,314,424);

        this.timeline.addTween(cjs.Tween.get(this.letter3).wait(1));

        // letter4
        this.letter4 = new lib.letter_02_L();
        this.letter4.name = "letter4";
        this.letter4.parent = this;
        this.letter4.setTransform(0,0,0.7,0.7);
        this.letter4.filters = [new cjs.ColorFilter(0.21, 0.21, 0.21, 1, 0, 0, 0, 0)];
        this.letter4.cache(-157,-212,314,424);

        this.timeline.addTween(cjs.Tween.get(this.letter4).wait(1));

        // letter5
        this.letter5 = new lib.letter_02_L();
        this.letter5.name = "letter5";
        this.letter5.parent = this;
        this.letter5.setTransform(0,0,0.6,0.6);
        this.letter5.filters = [new cjs.ColorFilter(0, 0, 0, 1, 0, 0, 0, 0)];
        this.letter5.cache(-157,-212,314,424);

        this.timeline.addTween(cjs.Tween.get(this.letter5).wait(1));

    }).prototype = getMCSymbolPrototype(lib.letter, new cjs.Rectangle(-155.1,-210,310.29999999999995,420), null);


    (lib.jan = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});

        // Layer_10
        this.vs = new lib.vs();
        this.vs.name = "vs";
        this.vs.parent = this;
        this.vs.setTransform(-358.3,-40.1);

        this.timeline.addTween(cjs.Tween.get(this.vs).wait(1));

        // Layer_3
        this.shdw = new lib.shadov();
        this.shdw.name = "shdw";
        this.shdw.parent = this;
        this.shdw.setTransform(-355.45,216.95);
        this.shdw.alpha = 0.1211;

        // this.timeline.addTween(cjs.Tween.get(this.shdw).wait(1));

        // Layer_2
        this.letter = new lib.letter();
        this.letter.name = "letter";
        this.letter.parent = this;
        this.letter.setTransform(38.05,40);

        this.timeline.addTween(cjs.Tween.get(this.letter).wait(1));

        // shapes8 (mask)
        var mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.moveTo(-96.4,152.6).curveTo(-124.5,123.2,-109,83.3).curveTo(-97.4,53.6,-75,40.2).curveTo(-52.8,26.7,-80.5,-6.3).curveTo(-108.1,-39.3,-76,-114.4).curveTo(-43.8,-189.6,42.6,-178).curveTo(101.4,-170.5,114.3,-101).curveTo(116.3,-52.3,97.3,-16.1).curveTo(78.1,19.9,51.3,39.5).curveTo(24.3,58.9,19.8,112.9).curveTo(15.2,166.9,-23.9,177.2).curveTo(-32.9,179.6,-41.5,179.6).curveTo(-70.7,179.6,-96.4,152.6).closePath();
        mask.setTransform(-36.5856,101.4698);

        // Layer_7
        this.p1 = new lib.ptrn4();
        this.p1.name = "p1";
        this.p1.parent = this;
        this.p1.setTransform(-50.4,95.55);

        var maskedShapeInstanceList = [this.p1];

        for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(cjs.Tween.get(this.p1).wait(1));

        // shapes7
        this.s2 = new lib.shapes7();
        this.s2.name = "s2";
        this.s2.parent = this;
        this.s2.setTransform(-292.15,-276.95,1,1,-83.9757,0,0,2.8,-0.1);

        this.timeline.addTween(cjs.Tween.get(this.s2).wait(1));

        // shapes5 (mask)
        var mask_1 = new cjs.Shape();
        mask_1._off = true;
        mask_1.graphics.moveTo(89.1,228).curveTo(63.2,213.5,49.7,183.9).curveTo(47.6,179.4,44.2,158.1).curveTo(39.8,131.2,36.6,117.9).curveTo(23.7,63.9,-2.4,59.2).curveTo(-20.4,55.9,-26,59).curveTo(-28,60.2,-30.6,63.3).curveTo(-34,67.4,-36.4,69.4).curveTo(-51.8,82.7,-62.7,92.9).curveTo(-73.6,103.2,-95.5,108.1).curveTo(-117.4,113,-139.5,101.9).curveTo(-161.5,90.7,-167.1,73.8).curveTo(-172.8,57,-168.7,38.3).curveTo(-164.6,19.7,-148.2,10.3).curveTo(-131.8,0.8,-134.7,-5).curveTo(-137.7,-10.8,-178.4,-40.8).curveTo(-192,-50.8,-196.5,-54.4).curveTo(-205.2,-61.3,-210.9,-67.5).curveTo(-224.1,-81.8,-233.3,-106.3).curveTo(-238.3,-119.6,-237.1,-136.1).curveTo(-236,-151.9,-229.5,-168).curveTo(-223,-184.2,-212.3,-197.6).curveTo(-201.1,-211.6,-187.2,-220.2).curveTo(-170.3,-230.5,-147.5,-235.2).curveTo(-124.9,-239.8,-103,-237.5).curveTo(-80,-235.2,-63.9,-225.8).curveTo(-46.3,-215.5,-40.3,-198.4).curveTo(-26.4,-155.8,-20.4,-139.4).curveTo(-10.8,-112.9,2.1,-93.5).curveTo(18.2,-69.2,45.7,-63.9).curveTo(71.5,-58.9,96.6,-72).curveTo(120.1,-84.2,139.8,-91).curveTo(158.7,-97.4,177.4,-99.9).curveTo(213.9,-104.8,231,-63.8).curveTo(248.1,-22.8,219.3,18.2).curveTo(216.7,22,212.6,25.1).curveTo(210.9,26.4,205.1,30.2).curveTo(195.3,36.5,190.9,44.4).curveTo(184.2,56.4,183.2,79.8).curveTo(182,107.8,188.4,155.4).curveTo(193.1,190.3,177.5,212.8).curveTo(163.5,233.2,138,237.3).curveTo(132.2,238.3,126.4,238.3).curveTo(107.4,238.3,89.1,228).closePath();
        mask_1.setTransform(-103.1217,-158.9656);

        // Layer_14
        this.p3 = new lib.pattern_img_4();
        this.p3.name = "p3";
        this.p3.parent = this;
        this.p3.setTransform(573,159);

        var maskedShapeInstanceList = [this.p3];

        for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_1;
        }

        this.timeline.addTween(cjs.Tween.get(this.p3).wait(1));

        // shapes6 (mask)
        var mask_2 = new cjs.Shape();
        mask_2._off = true;
        mask_2.graphics.moveTo(-89.2,123.9).curveTo(-122.8,98,-116.5,67.1).curveTo(-110.2,36.1,-156.6,25.8).curveTo(-202.9,15.6,-220.4,0.6).curveTo(-237.9,-14.3,-241.3,-29.6).curveTo(-244.7,-44.8,-242.7,-62.7).curveTo(-240.7,-80.6,-237.1,-103.3).curveTo(-233.4,-125.9,-200.7,-153.1).curveTo(-168,-180.3,-148.5,-165.3).curveTo(-129,-150.4,-104,-149.1).curveTo(-95.5,-148.1,-71.4,-159.3).curveTo(-47.4,-170.5,-28.3,-151.4).curveTo(-9.2,-132.2,-22.3,-95.9).curveTo(-35.4,-59.7,-26.7,-27.1).curveTo(-19.5,-0.3,33.4,14.5).curveTo(86.3,29.2,31.3,84.7).curveTo(-23.7,140.3,-39.6,145).curveTo(-42.1,145.8,-45,145.8).curveTo(-60.8,145.8,-89.2,123.9).closePath();
        mask_2.setTransform(-243.4747,-170.6415);

        // Layer_9
        this.p4 = new lib.ptrn4();
        this.p4.name = "p4";
        this.p4.parent = this;
        this.p4.setTransform(-532,-114.15);

        var maskedShapeInstanceList = [this.p4];

        for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask_2;
        }

        this.timeline.addTween(cjs.Tween.get(this.p4).wait(1));

    }).prototype = getMCSymbolPrototype(lib.jan, new cjs.Rectangle(-650.4,-397.2,843.5999999999999,678.3), null);


// stage content:
    (lib._01 = function(mode,startPosition,loop) {
        this.initialize(mode,startPosition,loop,{});
/*
        // timeline functions:
        this.frame_0 = function() {
            var tl = new TimelineMax();
            var tl2 = new TimelineMax();

            var time=0.31;
            var yb=0; // y begin
            var xb=-10; // x begin
            var xO=70;// x stop

            var x5=((xO-xb)/4)*(0)+xb;
            var x4=((xO-xb)/4)*(1)+xb;
            var x3=((xO-xb)/4)*(2)+xb;
            var x2=((xO-xb)/4)*(3)+xb;
            var x1=((xO-xb)/4)*(4)+xb;


            tl.set(this.jan, {x:750, y:610});
            // vs scales
            tl.set(this.jan.vs, {x:-159, y:5, scaleX:0.7, scaleY:0.7}, "start");
            tl.to(this.jan.vs, 2, {x:-356, y:-36, scaleX:1, scaleY:1 ,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.5" )

            tl2.set(this.jan.vs.hor, {rotation:-13}, "start")
            tl2.to(this.jan.vs.hor, 2, {ease: Sine.easeInOut, rotation:13,repeat:-1,yoyo:true}, "start")

            tl2.set(this.jan.vs.left, {x:-162,y:-117}, "start")
            tl2.to(this.jan.vs.left, 2, {x:-162.2,y:-197, ease: Sine.easeInOut, repeat:-1,yoyo:true}, "start")

            tl2.set(this.jan.vs.rgh, {x:162,y:-197}, "start")
            tl2.to(this.jan.vs.rgh, 2, {x:162.8,y:-124, ease: Sine.easeInOut, repeat:-1,yoyo:true}, "start")

            tl.set(this.jan.vs.rgh.apl, {alpha:0}, "start")
            tl.to(this.jan.vs.rgh.apl, 1, {alpha:1, }, "start+=1")

            tl.set(this.jan.vs.left.box, {alpha:0}, "start")
            tl.to(this.jan.vs.left.box, 1, {alpha:1, }, "start+=1")

            // ten
            tl.set(this.jan.shdw, {x:-159, y:200,alpha:0.1, scaleX:0.7, scaleY:0.7}, "start");
            tl.to(this.jan.shdw ,  2, {x:-356, y:200 ,alpha:0.2,scaleX:1, scaleY:1, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.5")



            // s1
            tl.set(this.jan.p1.mask, {x:-11, y:-3, scaleX:0, scaleY:0}, "start");
            tl.to(this.jan.p1.mask, 3, {x:-36, y:101, scaleX:1.6, scaleY:1.6,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")

            // p1


            tl.set(this.jan.p1, {x:-55, y:-20, scaleX:0.9, scaleY:0.9}, "start");
            tl.to(this.jan.p1,  4, {x:-52, y:95, scaleX:1.1, scaleY:1.1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")


            tl2.set(this.jan.p1.pt, {x:0, ease:Linear.easeNone}, "start");
            tl2.to(this.jan.p1.pt ,  40, {x:10,repeat:-1, ease:Linear.easeNone}, "start")

            // s2
            tl.set(this.jan.s2, {x:-50, y:-5, scaleX:0, scaleY:0,rotation:-84}, "start");
            tl.to(this.jan.s2,  2, {x:-300, y:-220, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")

            // s3
            tl.set(this.jan.p3.mask, {x:-200, y:-70, scaleX:0, scaleY:0}, "start");
            tl.to(this.jan.p3.mask,  2, {x:-200, y:-175, scaleX:1.2, scaleY:1.2, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9" )

            // p3
            tl.set(this.jan.p3, {x:-600, y:-190, scaleX:0.7, scaleY:0.7}, "start");
            tl.to(this.jan.p3,  5.7, {x:-626, y:-190, scaleX:1, scaleY:1, ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")

            tl2.set(this.jan.p3.pt, {rotation:360, ease:Linear.easeNone}, "start");
            tl2.to(this.jan.p3.pt,  600, {rotation:0,repeat:-1, ease:Linear.easeNone}, "start")
            // s4
            tl.set(this.jan.p4.mask, {x:-4, y:0, scaleX:0, scaleY:0},"start");
            tl.to(this.jan.p4.mask,  3.7, {x:-300, y:-100, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")

            // p4
            tl.set(this.jan.p4, {x:-41, y:10, scaleX:0.7, scaleY:0.7}, "start");
            tl.to(this.jan.p4,  3, {x:-447, y:-16, scaleX:1, scaleY:1,ease: CustomEase.create("custom", "M0,0,C0.074,-0.002,0.082,0.252,0.12,0.548,0.153,0.809,0.236,1,1,1")}, "start+=0.9")


            // ------------ litter---------


            tl.set(this.jan.letter.letter1, {x:x1, y:yb, alpha:0,}, "start");
            tl.to(this.jan.letter.letter1 ,  time+0.4, {x:x1, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.022,0.068 0.11,0.478 0.246,0.63 0.367,0.765 0.422,0.85 1,1")}, "start+=0.9")

            tl.set(this.jan.letter.letter2, {x:x2, y:yb, alpha:0}, "start");
            tl.to(this.jan.letter.letter2 ,  time+0.4, {x:x2, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0 C0.026,0.136 0.064,0.548 0.2,0.7 0.321,0.835 0.406,0.902 1,1")}, "start+=0.8")
            tl.to(this.jan.letter.letter2 ,  time+0.3, {alpha:0}, "start+=0.98")

            tl.set(this.jan.letter.letter3, {x:x3, y:yb, alpha:0}, "start");
            tl.to(this.jan.letter.letter3 ,  time+0.2, {x:x3, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.7")
            tl.to(this.jan.letter.letter3 ,  time-0.2, {alpha:0}, "start+=0.88")

            tl.set(this.jan.letter.letter4, {x:x4, y:yb, alpha:0}, "start");
            tl.to(this.jan.letter.letter4 , time+0.3, {x:x4, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0,0.27,0.028,0.626,0.164,0.778,0.285,0.913,0.422,0.974,1,1")}, "start+=0.6")
            tl.to(this.jan.letter.letter4 , time-0.3, {alpha:0}, "start+=0.78")

            tl.set(this.jan.letter.letter5, {x:x5, y:yb, alpha:1}, "start");
            tl.to(this.jan.letter.letter5 ,  time, {x:x5, y:yb, alpha:1,ease: CustomEase.create("custom", "M0,0,C0.01,0.406,0,0.708,0.136,0.86,0.257,0.995,0.308,1,1,1")}, "start+=0.4")
            tl.to(this.jan.letter.letter5 ,  time, {alpha:0}, "start+=0.68")


            // ------------ litter---------
        }

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));*/

        // logo_mc
        this.jan = new lib.jan();
        this.jan.name = "jan";
        this.jan.parent = this;
        this.jan.setTransform(800,670);

        this.timeline.addTween(cjs.Tween.get(this.jan).wait(1));

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(498,454,2375,1375);
// library properties:
    lib.properties = {
        id: 'CF21A2142ADA401E9DA4E5A26203859F',
        width: 1250,
        height: 1250,
        fps: 60,
        color: "#FFFFFF",
        opacity: 1.00,
        manifest: [
            {src:"images/_04.jpg", id:"_04"},
            {src:"images/apple.png", id:"apple"},
            {src:"images/Bitmap1.png", id:"Bitmap1"},
            {src:"images/box.png", id:"box"},
            {src:"images/vs_center.png", id:"vs_center"},
            {src:"images/vs_hor.png", id:"vs_hor"},
            {src:"images/vs_left.png", id:"vs_left"},
            {src:"images/vs_rght.png", id:"vs_rght"}
        ],
        preloads: []
    };



// bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    }
    p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
    p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
    p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
    p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

    p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if(!an.bootstrapListeners) {
        an.bootstrapListeners=[];
    }

    an.bootstrapCallback=function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if(an.bootcompsLoaded.length > 0) {
            for(var i=0; i<an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['CF01A2142ADA401E9DA4E5A26203859F'] = {
        getStage: function() { return exportRoot.getStage(); },
        getLibrary: function() { return lib; },
        getSpriteSheet: function() { return ss; },
        getImages: function() { return img; }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for(var j=0; j<an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    }

    an.getComposition = function(id) {
        return an.compositions[id];
    }




})(createjs = createjs||{}, AdobeAn = AdobeAn||{});

// export const AdobeAn = AdobeAn;
export const composition = AdobeAn.getComposition('CF01A2142ADA401E9DA4E5A26203859F');
